import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { array, string, bool } from 'prop-types'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { getInsightsObject, urlWithTrack } from '../../../helpers/common'
import AdSwiper from '../../ui/ad-swiper/AdSwiper'
import Image from '../../ui/image/Image'
import Insights from '../Insights'

/**
 * Component to render a widget with images like an  architects offices or companies widget
 *
 * @component
 * @example
 * return (
 *   <WidgetRoundedImage
 *    data={[
 *     {
 *       "name": "Zaha Hadid Architects",
 *       "image_url": "https://images.imagen1.jpg",
 *       "url": "https://www.archdaily.com/office/zaha-hadid-architects",
 *     },
 *     {
 *       "name": "AB Architects",
 *       "image_url": "https://images.imagen2.jpg",
 *       "url": "https://www.archdaily.com/office/ab-architects",
 *     }
 *    ]}
 *   />
 *  )
*/

const WidgetRoundedImage = ({
  data = EMPTY_ARRAY,
  widgetName = 'offices',
  searchType,
  query,
  isExpert,
  isCompanies
}) => {
  return (
    <AdSwiper isLazy goToSlideNumber={3} customClasses='swiper-widget' autoView>
      {data.map((item, index) => {
        const image = isExpert ? item.images[0] : item.image_url
        const insights = getInsightsObject(widgetName, item.name, index, true, searchType, query)
        const trackedUrl = urlWithTrack(item.url, searchType)
        return (
          <SwiperSlide key={item + index} lazy='true' >
            <Insights {...insights}>
              <a href={trackedUrl} key={item + index} title={item.name}>
                <div className='widget-with-image__image-wrapper'>
                  {/* eslint-disable-next-line max-len */}
                  <Image className='widget-with-image__image' src={image} placeholderWithBorderRadius={!isCompanies} loading='lazy' crop={false} />
                </div>
                <span className='widget-with-image__title'>{item.name}</span>
              </a>
            </Insights>
          </SwiperSlide>
        )
      })}
    </AdSwiper>
  )
}

WidgetRoundedImage.propTypes = {
  /**
   * Widget data
  */
  data: array,
  /**
   * Type of search
  */
  searchType: string,
  /**
   * Search query value
  */
  query: string,
  /**
   * Widget name
  */
  widgetName: string,
  /**
   * Is Expert Widget
  */
  isExpert: bool,
  /**
   * Is Company Widget
  */
  isCompanies: bool
}

export default WidgetRoundedImage